import { render } from "./ZutatenBearbeitenView.vue?vue&type=template&id=014c6952&scoped=true"
import script from "./ZutatenBearbeitenView.vue?vue&type=script&lang=js"
export * from "./ZutatenBearbeitenView.vue?vue&type=script&lang=js"

import "./ZutatenBearbeitenView.vue?vue&type=style&index=0&id=014c6952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014c6952"]])

export default __exports__